// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Employees-Staff-StaffDetail-EmployeeDeleteModal-__EmployeeDeleteModal___22Gu1","title":"app-pages-Employees-Staff-StaffDetail-EmployeeDeleteModal-__EmployeeDeleteModal___1ZxKI","dialog":"app-pages-Employees-Staff-StaffDetail-EmployeeDeleteModal-__EmployeeDeleteModal___24vzi","role":"app-pages-Employees-Staff-StaffDetail-EmployeeDeleteModal-__EmployeeDeleteModal___2HCX3"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/StaffDetail/EmployeeDeleteModal/EmployeeDeleteModal.css
// module id = 2336
// module chunks = 0